import { Box, Text } from "@chakra-ui/react";
import { ChatMessage, ChatParticipant } from "../../models/Chat";
import { formatDate } from "../../utils/date";

type Props = {
  sender: ChatParticipant;
  message: ChatMessage;
  isFromLoggedUser: boolean;
};

export default function ChatMessageItem({
  sender,
  message,
  isFromLoggedUser,
}: Props) {
  return (
    <Box
      shadow={"2px 2px 10px 2px #eee"}
      bg={isFromLoggedUser ? "white" : "primary.100"}
      borderColor={isFromLoggedUser ? "gray.200" : "primary.200"}
      px={4}
      py={2}
      borderRadius={12}
      borderWidth={1}
      maxW={350}
      alignSelf={isFromLoggedUser ? "flex-end" : "flex-start"}
    >
      {!isFromLoggedUser && (
        <Text fontSize="14" fontWeight="bold" color="primary.DEFAULT">
          {sender.fullName}
        </Text>
      )}
      <Text fontSize="16">{message.text}</Text>
      <Text mt={1} fontSize="12" alignSelf="flex-end" textAlign="right">
        {formatDate(message.createDateTime)}
      </Text>
    </Box>
  );
}
